/**
 * Checks if a given host element has a default (unnamed) slot.
 *
 * @param host - The host element to check.
 * @returns `true` if the default slot exists, `false` otherwise.
 */
function hasDefaultSlot(host) {
    return [...host.childNodes].some((node) => {
        if (node.nodeType === node.TEXT_NODE && node.textContent.trim() !== '') {
            return true;
        }
        if (node.nodeType === node.ELEMENT_NODE) {
            const el = node;
            // If it doesn't have a slot attribute, it's part of the default slot
            if (!el.hasAttribute('slot')) {
                return true;
            }
        }
        return false;
    });
}
/**
 * Checks if a given host element has a named slot.
 *
 * @param host - The host element to check.
 * @param slotName - The name of the slot to check for.
 * @returns `true` if the named slot exists, `false` otherwise.
 */
function hasNamedSlot(host, slotName) {
    if (!host || typeof host.querySelector !== 'function') {
        return false;
    }
    return host.querySelector(`:scope > [slot="${slotName}"]`) !== null;
}
/**
 * Retrieves the concatenated text content of all nodes in a default slot.
 *
 * @param slot - The slot element to extract text from.
 * @returns The concatenated text content of the slot's nodes, trimmed.
 */
function getDefaultSlotTextContent(slot) {
    if (!slot || typeof slot.assignedNodes !== 'function') {
        return '';
    }
    return slot.assignedNodes({ flatten: true }).reduce((acc, node) => { var _a; return acc + (((_a = node.textContent) === null || _a === void 0 ? void 0 : _a.trim()) || ''); }, '');
}
/**
 * Retrieves the text content of a named slot within a host element.
 *
 * @param host - The host element containing the named slot.
 * @param slotName - The name of the slot.
 * @returns The trimmed text content of the named slot, or an empty string if not found.
 */
function getNamedSlotTextContent(host, slotName) {
    var _a, _b;
    if (!host || typeof host.querySelector !== 'function') {
        return '';
    }
    return ((_b = (_a = host.querySelector(`:scope > [slot="${slotName}"]`)) === null || _a === void 0 ? void 0 : _a.textContent) === null || _b === void 0 ? void 0 : _b.trim()) || '';
}

export { getNamedSlotTextContent as a, hasDefaultSlot as b, getDefaultSlotTextContent as g, hasNamedSlot as h };
